import React, { Component } from 'react';
import $ from '../../common/AjaxRequest';
import { Modal, Button, Icon, message, Cascader } from 'antd';
import API_URL from '../../common/url';

class VisitMapped extends Component {
    state = {
        options : [],
        visible: false,
    };

    show = (moduleDefineCode, moduleDefineName) => {
        this.setState({
            visible: true,
            moduleDefineName,
            moduleDefineCode,
            showCascader: true,
        }, () => {
            this.loadData();
        });
    };

    hide = () => {
        this.setState({
            visible: false,
            selectedId: [],
            selectedOptions: [],
            showCascader: false,
        }, () => {
            this.props.loadData();
        });
    };

    loadData = () => {
        const { moduleDefineCode, moduleDefineName} = this.state;
        const options = {
            url: `${API_URL.execute.listVisitMapping}`,
            data: {
                moduleDefineCode,
                moduleDefineName,
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    this.setState({
                        dataList: res.success
                    }, () => {
                        this.loadHead();
                    });
                }
            }),
        };
        $.sendRequest(options);
    }

    loadHead = () => {
        const { dataList = [] } = this.state;
        const { investigationSiteName } = sessionStorage;
        const obj = {};
        if (!investigationSiteName) {
            obj.publishStatus = 'ALL';
        }
        const options = {
            url: `${API_URL.plan.queryVisitGrouping}`,
            data: { ...obj },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    if(res && res.data.length <=0)
                    {
                        return
                    }
                    const options = [];
                    res.data.map(item => {
                        let flag = false;
                        flag = dataList.some(innerItem => {
                            return innerItem.visitGroupingId == item.visitGroupingId;
                        })
                        if (!flag) {
                            options.push({
                                value: item.visitGroupingId,
                                label: item.visitGroupingName,
                                type: 'visitGroup',
                                isLeaf: false,
                            });
                        }
                    });
                    this.setState({ options });
                }
            }),
        };
        $.sendRequest(options);
    }

    loadVisitStage = (visitGroupingId) => {
        const options = {
            url: `${API_URL.execute.queryAllStageByVisitGroupingId}`,
            data: { visitGroupingId },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    const stageOptions = [];
                    res.data.map(item => {
                        stageOptions.push({
                            value: item.visitStageId,
                            label: item.stageValue,
                            type: 'visitStage',
                            isLeaf: false,
                        })
                    });
                    this.setState({ stageOptions });
                }
            }),
        };
        $.sendRequest(options);
    }

    loadVisitPeriod = (visitStageId) => {
        const options = {
            url: `${API_URL.execute.queryVisitPeroidAndVisit}`,
            data: { visitStageId },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    const periodOptions = [];
                    res.data.map(item => {
                        periodOptions.push({
                            value: item.type == 'visit_period' ? item.visitPeriodId : item.visitTypeId,
                            label: item.type == 'visit_period' ? item.periodValue : item.visitTypeName,
                            type: item.type,
                            isLeaf: item.type == 'visit_period' ? false : true,
                        })
                    });
                    this.setState({ periodOptions });
                }
            }),
        };
        $.sendRequest(options);
    }

    loadVisitType = (visitPeriodId) => {
        const options = {
            url: `${API_URL.execute.queryVisitTypeByPeriodId}`,
            data: { visitPeriodId },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    const typeOptions = [];
                    res.data.map(item => {
                        typeOptions.push({
                            value: item.visitTypeId,
                            label: item.visitTypeName,
                            type: 'visit_type',
                        })
                    });
                    this.setState({ typeOptions });
                }
            }),
        };
        $.sendRequest(options);
    }

    handleAddBtn = () => {
        const { selectedId = [], selectedOptions = [], moduleDefineCode, moduleDefineName } = this.state;
        if (selectedOptions.length <= 0) {
            message.warning('请映射访视次数');
            return;
        } else {
            if (selectedOptions[selectedOptions.length - 1].type != 'visit_type') {
                message.warning('请映射访视次数');
                return;
            }
        }

        const options = {
            method: 'POST',
            url: API_URL.execute.addVisitMapping,
            data: {
                moduleDefineName,
                moduleDefineCode,
                visitGroupingId: selectedId[0],
                visitTypeId: selectedId[selectedId.length - 1],
            },
            dataType: 'json',
            doneResult: ( res => {
                if (!res.error) {
                    message.success(res.success);
                    this.setState({
                        options: [],
                        selectedId: [],
                        selectedOptions: [],
                        showCascader: false,
                    }, () => {
                        this.setState({ showCascader: true });
                        this.loadData();
                    });
                } else {
                    message.error(res.error);
                }
            }),
        };
        $.sendRequest(options);
    }

    handleRemoveItem = (e, visitMappingId) => {
        const options = {
            url: API_URL.execute.deleleVisitMapping,
            data: { visitMappingId },
            dataType: 'json',
            doneResult: ( res => {
                if (!res.error) {
                    message.success(res.success);
                    this.loadData();
                } else {
                    message.error(res.error);
                }
            }),
        };
        $.sendRequest(options);
    }

    getDataList = () => {
        const { dataList = [] } = this.state;
        let data = null;
        if (dataList.length > 0) {
            data = dataList.map((item, index) => {
                const { showName, visitMappingId, sign } = item;
                return (
                    <div key={visitMappingId}>
                        <div style={{position: 'relative', marginBottom: 4, paddingLeft: 10, paddingRight: 20, background: '#f1f1f1'}}>
                            <div>{showName}</div>
                            {
                                sign != '1' &&
                                <Icon style={{position: 'absolute', top: 5, right: 5, color: 'red', cursor: 'pointer'}}type="close-circle-o" onClick={e => this.handleRemoveItem(e, visitMappingId)}/>
                            }
                        </div>
                    </div> 
                );  
            });
        }
        return data;
    }

    onChange = (value, selectedOptions) => {
        this.setState({
            selectedId: [...value],
            selectedOptions: [...selectedOptions],
        });
    }

    loadCascaderData = (selectedOptions) => {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;

        const type = targetOption.type;
        if (type == 'visitGroup') {
            this.loadVisitStage(targetOption.value);
        } else if (type == 'visitStage') {
            this.loadVisitPeriod(targetOption.value);
        } else if (type == 'visit_period') {
            this.loadVisitType(targetOption.value);
        }

        setTimeout(() => {
            const { stageOptions = [], periodOptions = [], typeOptions = [] } = this.state;
            targetOption.loading = false;

            if (type == 'visitGroup') {
                targetOption.children = [ ...stageOptions ];
            } else if (type == 'visitStage') {
                targetOption.children = [ ...periodOptions ];
            } else if (type == 'visit_period') {
                targetOption.children = [ ...typeOptions ];
            }

            this.setState({
                options: [...this.state.options],
            });
        }, 400);
    }

    render() {
        const { visible, showCascader = true, options = [] } = this.state;
        const disabled = options.length == 0 ? true : false;
        return (
            <Modal
                title="设置映射"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="680px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div className="modal-content">
                    <ul className="modal-list">
                        <li className="modal-item" style={{paddingBottom: 20, borderBottom: '1px solid #dcdcdc'}}>
                            <div className="item-left" style={{width: 86, paddingRight: 10}}>访视次数:</div>
                            <div className="item-right" style={{width: 444}}>
                                {
                                    showCascader &&
                                    <Cascader
                                        style={{width: 444}}
                                        options={options}
                                        loadData={this.loadCascaderData}
                                        onChange={this.onChange}
                                        placeholder='请选择'
                                        changeOnSelect
                                    />
                                }
                            </div>
                            {
                                !disabled ?
                                    <Button type="primary" style={{marginLeft: 20}} onClick={this.handleAddBtn}>添加</Button>
                                :
                                    <Button type="primary" style={{marginLeft: 20}} disabled={true}>添加</Button>
                            }
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{width: 86, paddingRight: 10}}>已设映射访视:</div>
                            <div className="item-right" style={{width: '73%'}}>
                            { this.getDataList() }
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default VisitMapped;


// WEBPACK FOOTER //
// ./src/components/executeMgr/CrfModal.js